import { get, post, put, deleted } from '..';
import routes from './routes';

const BrandServices = {
  createBrand: async (obj) => {
    const data = await post(routes.createBrand, obj);
    return data;
  },
  getBrands: async (params) => {
    const data = await get(routes.getBrands, params);
    return data;
  },
  getBrandById: async (id) => {
    const data = await get(routes.getBrandById + id);
    return data;
  },
  updateBrand: async (id, obj) => {
    const data = await put(routes.updateBrand + id, obj);
    return data;
  },
  deleteBrand: async (id) => {
    const data = await deleted(routes.deleteBrand + id);
    return data;
  },
}

export default BrandServices